export const FETCH_STUFF_TO_DO_LIST_START = 'FETCH_STUFF_TO_DO_LIST_START';
export const FETCH_STUFF_TO_DO_LIST_ERROR = 'FETCH_STUFF_TO_DO_LIST_ERROR';
export const RECEIVE_STUFF_TO_DO_LIST = 'RECEIVE_STUFF_TO_DO_LIST';
export const CLEAR_STUFF_TO_DO_LIST_STORE = 'CLEAR_STUFF_TO_DO_LIST_STORE';

export const FETCH_STUFF_TO_DO_DETAILS_START = 'FETCH_STUFF_TO_DO_DETAILS_START';
export const FETCH_STUFF_TO_DO_DETAILS_ERROR = 'FETCH_STUFF_TO_DO_DETAILS_ERROR';
export const FETCH_STUFF_TO_DO_DETAILS_NOT_FOUND = 'FETCH_STUFF_TO_DO_DETAILS_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_DETAILS = 'RECEIVE_STUFF_TO_DO_DETAILS';
export const SAVE_STUFF_TO_DO_DETAILS_START = 'SAVE_STUFF_TO_DO_DETAILS_START';
export const SAVE_STUFF_TO_DO_DETAILS_SUCCESSFUL = 'SAVE_STUFF_TO_DO_DETAILS_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_DETAILS_ERROR = 'SAVE_STUFF_TO_DO_DETAILS_ERROR';
export const CLEAR_STUFF_TO_DO_DETAILS_STORE = 'CLEAR_STUFF_TO_DO_DETAILS_STORE';

export const FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_START = 'FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_START';
export const FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR = 'FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR';
export const FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_NOT_FOUND = 'FETCH_STUFF_TO_DO_NUTRITION_INFORMATION_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_NUTRITION_INFORMATION = 'RECEIVE_STUFF_TO_DO_NUTRITION_INFORMATION';
export const SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_START = 'SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_START';
export const SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_SUCCESSFUL = 'SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR = 'SAVE_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR';
export const CLEAR_STUFF_TO_DO_NUTRITION_INFORMATION_STORE = 'CLEAR_STUFF_TO_DO_NUTRITION_INFORMATION_STORE';

export const FETCH_STUFF_TO_DO_CONTENTS_START = 'FETCH_STUFF_TO_DO_CONTENTS_START';
export const FETCH_STUFF_TO_DO_CONTENTS_ERROR = 'FETCH_STUFF_TO_DO_CONTENTS_ERROR';
export const RECEIVE_STUFF_TO_DO_CONTENTS = 'RECEIVE_STUFF_TO_DO_CONTENTS';
export const CLEAR_STUFF_TO_DO_CONTENTS = 'CLEAR_STUFF_TO_DO_CONTENTS';
export const SAVE_STUFF_TO_DO_CONTENT_START = 'SAVE_STUFF_TO_DO_CONTENT_START';
export const SAVE_STUFF_TO_DO_CONTENT_SUCCESSFUL = 'SAVE_STUFF_TO_DO_CONTENT_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_CONTENT_ERROR = 'SAVE_STUFF_TO_DO_CONTENT_ERROR';
export const FETCH_STUFF_TO_DO_CONTENT_START = 'FETCH_STUFF_TO_DO_CONTENT_START';
export const FETCH_STUFF_TO_DO_CONTENT_ERROR = 'FETCH_STUFF_TO_DO_CONTENT_ERROR';
export const RECEIVE_STUFF_TO_DO_CONTENT = 'RECEIVE_STUFF_TO_DO_CONTENT';
export const CLEAR_STUFF_TO_DO_CONTENT = 'CLEAR_STUFF_TO_DO_CONTENT';
export const UPDATE_STUFF_TO_DO_CONTENT_START = 'UPDATE_STUFF_TO_DO_CONTENT_START';
export const UPDATE_STUFF_TO_DO_CONTENT_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_CONTENT_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_CONTENT_ERROR = 'UPDATE_STUFF_TO_DO_CONTENT_ERROR';
export const REMOVE_STUFF_TO_DO_CONTENT_START = 'REMOVE_STUFF_TO_DO_CONTENT_START';
export const REMOVE_STUFF_TO_DO_CONTENT_SUCCESSFUL = 'REMOVE_STUFF_TO_DO_CONTENT_SUCCESSFUL';
export const REMOVE_STUFF_TO_DO_CONTENT_ERROR = 'REMOVE_STUFF_TO_DO_CONTENT_ERROR';
export const UPDATE_STUFF_TO_DO_CONTENT_SEQUENCE_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_CONTENT_SEQUENCE_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_CONTENT_SEQUENCE_ERROR = 'UPDATE_STUFF_TO_DO_CONTENT_SEQUENCE_ERROR';

export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_START = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_START';
export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_ERROR = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_ERROR';
export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_NOT_FOUND = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_NUTRITION_FACTS = 'RECEIVE_STUFF_TO_DO_NUTRITION_FACTS';
export const CLEAR_STUFF_TO_DO_NUTRITION_FACTS = 'CLEAR_STUFF_TO_DO_NUTRITION_FACTS';

export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_START = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_START';
export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_ERROR = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_ERROR';
export const FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_NOT_FOUND = 'FETCH_STUFF_TO_DO_NUTRITION_FACTS_LABEL_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_NUTRITION_FACTS_LABEL = 'RECEIVE_STUFF_TO_DO_NUTRITION_FACTS_LABEL';
export const CLEAR_STUFF_TO_DO_NUTRITION_FACTS_LABEL = 'CLEAR_STUFF_TO_DO_NUTRITION_FACTS_LABEL';

export const FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_START = 'FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_START';
export const FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_ERROR = 'FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_ERROR';
export const FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_NOT_FOUND = 'FETCH_STUFF_TO_DO_NUTRITION_PREDICTION_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_NUTRITION_PREDICTION = 'RECEIVE_STUFF_TO_DO_NUTRITION_PREDICTION';
export const CLEAR_STUFF_TO_DO_NUTRITION_PREDICTION = 'CLEAR_STUFF_TO_DO_NUTRITION_PREDICTION';

export const ADD_TO_RECENTLY_MODIFIED_LIST = 'ADD_TO_RECENTLY_MODIFIED_LIST';
export const REMOVE_FROM_RECENTLY_MODIFIED_LIST = 'REMOVE_FROM_RECENTLY_MODIFIED_LIST';

// categories
export const FETCH_STUFF_TO_DO_CATEGORIES_START = 'FETCH_STUFF_TO_DO_CATEGORIES_START';
export const FETCH_STUFF_TO_DO_CATEGORIES_ERROR = 'FETCH_STUFF_TO_DO_CATEGORIES_ERROR';
export const FETCH_STUFF_TO_DO_CATEGORIES_NOT_FOUND = 'FETCH_STUFF_TO_DO_CATEGORIES_NOT_FOUND';
export const RECEIVE_STUFF_TO_DO_CATEGORIES = 'RECEIVE_STUFF_TO_DO_CATEGORIES';
export const CLEAR_STUFF_TO_DO_CATEGORIES = 'CLEAR_STUFF_TO_DO_CATEGORIES';
// categories

// type categories
export const FETCH_STUFF_TO_DO_TYPE_CATEGORIES_START = 'FETCH_STUFF_TO_DO_TYPE_CATEGORIES_START';
export const FETCH_STUFF_TO_DO_TYPE_CATEGORIES_ERROR = 'FETCH_STUFF_TO_DO_TYPE_CATEGORIES_ERROR';
export const RECEIVE_STUFF_TO_DO_TYPE_CATEGORIES = 'RECEIVE_STUFF_TO_DO_TYPE_CATEGORIES';
export const CLEAR_STUFF_TO_DO_TYPE_CATEGORIES_STORE = 'CLEAR_STUFF_TO_DO_TYPE_CATEGORIES_STORE';
export const SAVE_STUFF_TO_DO_CATEGORIES_START = 'SAVE_STUFF_TO_DO_CATEGORIES_START';
export const SAVE_STUFF_TO_DO_CATEGORIES_SUCCESSFUL = 'SAVE_STUFF_TO_DO_CATEGORIES_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_CATEGORIES_ERROR = 'SAVE_STUFF_TO_DO_CATEGORIES_ERROR';
// type categories

// stuff-to-eat-serving-sizes
export const FETCH_STUFF_TO_DO_SERVING_SIZES_START = 'FETCH_STUFF_TO_DO_SERVING_SIZES_START';
export const FETCH_STUFF_TO_DO_SERVING_SIZES_ERROR = 'FETCH_STUFF_TO_DO_SERVING_SIZES_ERROR';
export const RECEIVE_STUFF_TO_DO_SERVING_SIZES = 'RECEIVE_STUFF_TO_DO_SERVING_SIZES';

export const CLEAR_STUFF_TO_DO_SERVING_SIZES = 'CLEAR_STUFF_TO_DO_SERVING_SIZES';

export const SAVE_STUFF_TO_DO_SERVING_SIZE_START = 'SAVE_STUFF_TO_DO_SERVING_SIZE_START';
export const SAVE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL = 'SAVE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_SERVING_SIZE_ERROR = 'SAVE_STUFF_TO_DO_SERVING_SIZE_ERROR';

export const FETCH_STUFF_TO_DO_SERVING_SIZE_START = 'FETCH_STUFF_TO_DO_SERVING_SIZE_START';
export const FETCH_STUFF_TO_DO_SERVING_SIZE_ERROR = 'FETCH_STUFF_TO_DO_SERVING_SIZE_ERROR';
export const RECEIVE_STUFF_TO_DO_SERVING_SIZE = 'RECEIVE_STUFF_TO_DO_SERVING_SIZE';

export const UPDATE_STUFF_TO_DO_SERVING_SIZE_START = 'UPDATE_STUFF_TO_DO_SERVING_SIZE_START';
export const UPDATE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_SERVING_SIZE_ERROR = 'UPDATE_STUFF_TO_DO_SERVING_SIZE_ERROR';

export const DELETE_STUFF_TO_DO_SERVING_SIZE_START = 'DELETE_STUFF_TO_DO_SERVING_SIZE_START';
export const DELETE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL = 'DELETE_STUFF_TO_DO_SERVING_SIZE_SUCCESSFUL';
export const DELETE_STUFF_TO_DO_SERVING_SIZE_ERROR = 'DELETE_STUFF_TO_DO_SERVING_SIZE_ERROR';

export const CLEAR_STUFF_TO_DO_SERVING_SIZE = 'CLEAR_STUFF_TO_DO_SERVING_SIZE';


export const ADD_STUFF_TO_DO_SERVING_SIZE_TO_SERVING_SIZE_LIST = 'ADD_STUFF_TO_DO_SERVING_SIZE_TO_SERVING_SIZE_LIST';
export const EDIT_STUFF_TO_DO_SERVING_SIZE_IN_SERVING_SIZE_LIST = 'EDIT_STUFF_TO_DO_SERVING_SIZE_IN_SERVING_SIZE_LIST';
export const REMOVE_STUFF_TO_DO_SERVING_SIZE_FROM_SERVING_SIZE_LIST = 'REMOVE_STUFF_TO_DO_SERVING_SIZE_FROM_SERVING_SIZE_LIST';

export const ADD_SERVING_SIZE_TO_STUFF_TO_DO_DETAILS = 'ADD_SERVING_SIZE_TO_STUFF_TO_DO_DETAILS';
// stuff-to-eat-serving-sizes

// stuff-to-eat-exchanges
export const FETCH_STUFF_TO_DO_EXCHANGES_START = 'FETCH_STUFF_TO_DO_EXCHANGES_START';
export const FETCH_STUFF_TO_DO_EXCHANGES_ERROR = 'FETCH_STUFF_TO_DO_EXCHANGES_ERROR';
export const RECEIVE_STUFF_TO_DO_EXCHANGES = 'RECEIVE_STUFF_TO_DO_EXCHANGES';

export const CLEAR_STUFF_TO_DO_EXCHANGES = 'CLEAR_STUFF_TO_DO_EXCHANGES';

export const SAVE_STUFF_TO_DO_EXCHANGE_START = 'SAVE_STUFF_TO_DO_EXCHANGE_START';
export const SAVE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL = 'SAVE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_EXCHANGE_ERROR = 'SAVE_STUFF_TO_DO_EXCHANGE_ERROR';

export const FETCH_STUFF_TO_DO_EXCHANGE_START = 'FETCH_STUFF_TO_DO_EXCHANGE_START';
export const FETCH_STUFF_TO_DO_EXCHANGE_ERROR = 'FETCH_STUFF_TO_DO_EXCHANGE_ERROR';
export const RECEIVE_STUFF_TO_DO_EXCHANGE = 'RECEIVE_STUFF_TO_DO_EXCHANGE';

export const UPDATE_STUFF_TO_DO_EXCHANGE_START = 'UPDATE_STUFF_TO_DO_EXCHANGE_START';
export const UPDATE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_EXCHANGE_ERROR = 'UPDATE_STUFF_TO_DO_EXCHANGE_ERROR';

export const DELETE_STUFF_TO_DO_EXCHANGE_START = 'DELETE_STUFF_TO_DO_EXCHANGE_START';
export const DELETE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL = 'DELETE_STUFF_TO_DO_EXCHANGE_SUCCESSFUL';
export const DELETE_STUFF_TO_DO_EXCHANGE_ERROR = 'DELETE_STUFF_TO_DO_EXCHANGE_ERROR';

export const CLEAR_STUFF_TO_DO_EXCHANGE = 'CLEAR_STUFF_TO_DO_EXCHANGE';

export const ADD_STUFF_TO_DO_EXCHANGE_TO_EXCHANGE_LIST = 'ADD_STUFF_TO_DO_EXCHANGE_TO_EXCHANGE_LIST';
export const EDIT_STUFF_TO_DO_EXCHANGE_IN_EXCHANGE_LIST = 'EDIT_STUFF_TO_DO_EXCHANGE_IN_EXCHANGE_LIST';
export const REMOVE_STUFF_TO_DO_EXCHANGE_FROM_EXCHANGE_LIST = 'REMOVE_STUFF_TO_DO_EXCHANGE_FROM_EXCHANGE_LIST';

export const ADD_EXCHANGE_TO_STUFF_TO_DO_DETAILS = 'ADD_EXCHANGE_TO_STUFF_TO_DO_DETAILS';
// stuff-to-eat-exchanges

// stuff-to-eat-images
export const FETCH_STUFF_TO_DO_IMAGES_START = 'FETCH_STUFF_TO_DO_IMAGES_START';
export const FETCH_STUFF_TO_DO_IMAGES_ERROR = 'FETCH_STUFF_TO_DO_IMAGES_ERROR';
export const RECEIVE_STUFF_TO_DO_IMAGES = 'RECEIVE_STUFF_TO_DO_IMAGES';
export const CLEAR_STUFF_TO_DO_IMAGES = 'CLEAR_STUFF_TO_DO_IMAGES';
export const UPLOAD_STUFF_TO_DO_IMAGE_START = 'UPLOAD_STUFF_TO_DO_IMAGE_START';
export const UPLOAD_STUFF_TO_DO_IMAGE_SUCCESSFUL = 'UPLOAD_STUFF_TO_DO_IMAGE_SUCCESSFUL';
export const UPLOAD_STUFF_TO_DO_IMAGE_ERROR = 'UPLOAD_STUFF_TO_DO_IMAGE_ERROR';
export const STUFF_TO_DO_IMAGE_SET_MAIN_START = 'STUFF_TO_DO_IMAGE_SET_MAIN_START';
export const STUFF_TO_DO_IMAGE_SET_MAIN_SUCCESSFUL = 'STUFF_TO_DO_IMAGE_SET_MAIN_SUCCESSFUL';
export const STUFF_TO_DO_IMAGE_SET_MAIN_ERROR = 'STUFF_TO_DO_IMAGE_SET_MAIN_ERROR';
export const REMOVE_STUFF_TO_DO_IMAGES_START = 'REMOVE_STUFF_TO_DO_IMAGES_START';
export const REMOVE_STUFF_TO_DO_IMAGES_SUCCESSFUL = 'REMOVE_STUFF_TO_DO_IMAGES_SUCCESSFUL';
export const REMOVE_STUFF_TO_DO_IMAGES_ERROR = 'REMOVE_STUFF_TO_DO_IMAGES_ERROR';
export const UPDATE_STUFF_TO_DO_IMAGES_START = 'UPDATE_STUFF_TO_DO_IMAGES_START';
export const UPDATE_STUFF_TO_DO_IMAGES_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_IMAGES_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_IMAGES_ERROR = 'UPDATE_STUFF_TO_DO_IMAGES_ERROR';
// stuff-to-eat-images

// stuff-to-eat-instructions
export const FETCH_STUFF_TO_DO_INSTRUCTIONS_START = 'FETCH_STUFF_TO_DO_INSTRUCTIONS_START';
export const FETCH_STUFF_TO_DO_INSTRUCTIONS_ERROR = 'FETCH_STUFF_TO_DO_INSTRUCTIONS_ERROR';
export const RECEIVE_STUFF_TO_DO_INSTRUCTIONS = 'RECEIVE_STUFF_TO_DO_INSTRUCTIONS';

export const CLEAR_STUFF_TO_DO_INSTRUCTIONS = 'CLEAR_STUFF_TO_DO_INSTRUCTIONS';

export const SAVE_STUFF_TO_DO_INSTRUCTION_START = 'SAVE_STUFF_TO_DO_INSTRUCTION_START';
export const SAVE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL = 'SAVE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_INSTRUCTION_ERROR = 'SAVE_STUFF_TO_DO_INSTRUCTION_ERROR';

export const FETCH_STUFF_TO_DO_INSTRUCTION_START = 'FETCH_STUFF_TO_DO_INSTRUCTION_START';
export const FETCH_STUFF_TO_DO_INSTRUCTION_ERROR = 'FETCH_STUFF_TO_DO_INSTRUCTION_ERROR';
export const RECEIVE_STUFF_TO_DO_INSTRUCTION = 'RECEIVE_STUFF_TO_DO_INSTRUCTION';

export const UPDATE_STUFF_TO_DO_INSTRUCTION_START = 'UPDATE_STUFF_TO_DO_INSTRUCTION_START';
export const UPDATE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_INSTRUCTION_ERROR = 'UPDATE_STUFF_TO_DO_INSTRUCTION_ERROR';

export const DELETE_STUFF_TO_DO_INSTRUCTION_START = 'DELETE_STUFF_TO_DO_INSTRUCTION_START';
export const DELETE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL = 'DELETE_STUFF_TO_DO_INSTRUCTION_SUCCESSFUL';
export const DELETE_STUFF_TO_DO_INSTRUCTION_ERROR = 'DELETE_STUFF_TO_DO_INSTRUCTION_ERROR';

export const CLEAR_STUFF_TO_DO_INSTRUCTION = 'CLEAR_STUFF_TO_DO_INSTRUCTION';

export const ADD_STUFF_TO_DO_INSTRUCTION_TO_INSTRUCTION_LIST = 'ADD_STUFF_TO_DO_INSTRUCTION_TO_INSTRUCTION_LIST';
export const EDIT_STUFF_TO_DO_INSTRUCTION_IN_INSTRUCTION_LIST = 'EDIT_STUFF_TO_DO_INSTRUCTION_IN_INSTRUCTION_LIST';
export const REMOVE_STUFF_TO_DO_INSTRUCTION_FROM_INSTRUCTION_LIST = 'REMOVE_STUFF_TO_DO_INSTRUCTION_FROM_INSTRUCTION_LIST';

export const UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_START = 'UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_START';
export const UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_SUCCESSFUL = 'UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_SUCCESSFUL';
export const UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_ERROR = 'UPDATE_STUFF_TO_DO_INSTRUCTIONS_SEQUENCE_ERROR';

export const ADD_INSTRUCTION_TO_STUFF_TO_DO_DETAILS = 'ADD_INSTRUCTION_TO_STUFF_TO_DO_DETAILS';
// stuff-to-eat-instructions

// delete
export const DELETE_STUFF_TO_DO_START = 'DELETE_STUFF_TO_DO_START';
export const DELETE_STUFF_TO_DO_SUCCESSFUL = 'DELETE_STUFF_TO_DO_SUCCESSFUL';
export const DELETE_STUFF_TO_DO_ERROR = 'DELETE_STUFF_TO_DO_ERROR';
// delete

// nutrition_information_manual_control
export const SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_START = 'SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_START';
export const SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_SUCCESSFUL = 'SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_SUCCESSFUL';
export const SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_ERROR = 'SET_STUFF_TO_DO_NUTRITION_INFORMATION_MANUAL_CONTROL_ERROR';
// nutrition_information_manual_control

// recreate nutrition_information
export const RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_START = 'RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_START';
export const RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_SUCCESSFUL = 'RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_SUCCESSFUL';
export const RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR = 'RECREATE_STUFF_TO_DO_NUTRITION_INFORMATION_ERROR';
// recreate nutrition_information

// SET STATUS
export const SAVE_STUFF_TO_DO_STATUS_START = 'SAVE_STUFF_TO_DO_STATUS_START';
export const SAVE_STUFF_TO_DO_STATUS_SUCCESSFUL = 'SAVE_STUFF_TO_DO_STATUS_SUCCESSFUL';
export const SAVE_STUFF_TO_DO_STATUS_ERROR = 'SAVE_STUFF_TO_DO_STATUS_ERROR';

export const UPDATE_STUFF_TO_DO_DETAILS_NUTRITION_INFO = 'UPDATE_STUFF_TO_DO_DETAILS_NUTRITION_INFO';



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-do/mutation-types.js